var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/analyze/index.tsx",
  _this = this;
import React from 'react';
import ButtonCreate from '../../components/actions/ButtonCreate';
import BaseMenu from '../../components/navigation/BaseMenu';
import { UserMenu } from '../../components/user-menu';
import { InfoMenu } from '../../components/info-menu';
var analyze = {
  getMenuItems: function getMenuItems(experiment) {
    return [/*#__PURE__*/React.createElement(BaseMenu, {
      key: "base-menu",
      experiment: experiment,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 10,
        columnNumber: 13
      }
    })];
  },
  actions: [/*#__PURE__*/React.createElement(ButtonCreate, {
    key: "action-create",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 13
    }
  })],
  info: [/*#__PURE__*/React.createElement(InfoMenu, {
    key: "menu-info",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 10
    }
  })],
  user: [/*#__PURE__*/React.createElement(UserMenu, {
    key: "menu-user",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 10
    }
  })],
  homePage: '/'
};
export default analyze;
//# sourceMappingURL=index.js.map